import Button from "../../components/Button";
import { useStore } from "../../store";
import { toJS } from "mobx";
import { Step } from "../../components/Step";
import TemperatureChart from "../../components/TemperatureChart";
import TemperatureDisplay from "../../components/TemperatureDisplay";
import { cToF } from "../../utils";
import { useEffect, useMemo, useState } from "react";
import InputModal, { InputModalProps } from "../../components/InputModal";
import { getRouterPath } from "../../utils/route";
import { useNavigate } from "react-router-dom";

export type RecordProps = {
  options: {
    cb?(): void,
    type: string
  }
};

function MenuLogRecord(props: RecordProps) {



  const { options } = props;
  const { dataStore } = useStore();
  const resData = dataStore.resData;
  const programName = resData.loadLogContentAck?.logContent.program.name;
  const steps = resData.loadLogContentAck?.logContent.program.steps || [];
  const logContent = resData.loadLogContentAck?.logContent;




  const [saveLogModal, setSaveLogModal] = useState<InputModalProps>({
    isOpen: false,
    title: "Save log as:",
    value: "",
    onSave: (value: string) => { },
    onCancel: () => {
      setSaveLogModal((data) => ({ ...data, isOpen: false }));
    },
  });




  const navigate = useNavigate()

  // save
  let onClickSaveRecord = function (value: string) {
    dataStore.sendData({
      action: "saveUserLog",
      data: {
        logId: logContent?.id || "",
        logName: value,
        type: options.type
      },
    });

  };

  useEffect(() => {
    dataStore.setNav({ title: "Log record" });
  }, [])


  const chartRecord = useMemo(
    () => {

      const records: {
        data: {
          temperature: number;
          humidity: number;
          time: string;
          step?: number
        }[];
      } = { data: [] };



      for (const data of logContent?.data || []) {
        for (const itemData of data.data) {
          records.data.push(itemData);
        }
      }


      if (resData.loadSettingAck?.temperatureUnit === 'F') {
        records.data = records.data.map(item => ({ ...item, temperature: Number(cToF(item.temperature)) }))
      }


      const temperature = records.data.map(item => {
        let targetData: number | undefined
        if (steps.length && typeof (item.step) === 'number') {
          const stepData = steps[item.step]

          targetData = resData.loadSettingAck?.temperatureUnit === 'F' ? Number(cToF(stepData.temperature)) : stepData.temperature

        }

        return { data: item.temperature, time: item.time, targetData }
      })


      return {
        temperature,
        humidity: records.data.map(item => ({ data: item.humidity, time: item.time })),
      }
    },
    [logContent?.data, steps] // 依赖 MobX 原始数组引用，只有它变才重新生成
  );

  return (
    <div className="flex">
      <div className="w-[1280px] h-[730px] flex">
        <div
          className="flex"
          style={{
            flex: 1,
          }}
        >
          {/* 左侧 */}
          <Step
            resData={resData}
            state={"LOGGED"}
            style={{
              marginLeft: 15,
              alignSelf: "center",
            }}
            title={programName}
            steps={steps}
            selectStepIndex={0}
          />

          {/* 右侧 */}
          <div
            className="flex"
            style={{
              flexDirection: "column",
              flex: 1,
              alignItems: "center",
              justifyContent: "space-between",
              paddingBottom: 30,
              paddingTop: 30,
            }}
          >
            <div
              style={{
                marginTop: 0,
              }}
            >

              {logContent?.name && (
                <div
                  className="flex"
                  style={{
                    width: '50vw',
                    justifyContent: 'flex-start',
                    marginLeft: 70,
                  }}
                >
                  <div
                    style={{
                      width: '100%',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      color: 'white',
                      fontSize: 40,
                      fontWeight: '800',
                    }}
                  >{logContent?.name}</div>
                </div>

              )}

              <TemperatureDisplay
                unit={resData.loadSettingAck?.temperatureUnit as any}
                dateFormat={resData.loadSettingAck?.dateFormat}
                style={{
                  marginLeft: 75,
                  marginBottom: 50,
                  opacity: 0.8
                }}
                startedAt={logContent?.startTime}
                finishedAt={logContent?.endTime}
                state={"LOGGED"}
                steps={steps}
                runTotalText={logContent?.usedTime}
              />


              <TemperatureChart
                dateFormat={resData.loadSettingAck?.dateFormat}

                unit={resData.loadSettingAck?.temperatureUnit as any}

                style={{
                  width: "100%",
                  height: resData.loadSettingAck?.humidityEnabled ? 160 : 340,
                  marginTop: 30,
                }}
                records={chartRecord.temperature}
              />


              {resData.loadSettingAck?.humidityEnabled && (
                <TemperatureChart
                  dateFormat={resData.loadSettingAck?.dateFormat}

                  unit={'RH'}

                  style={{
                    width: "100%",
                    height: 140,
                    marginTop: 30,
                  }}
                  records={chartRecord.humidity}
                />
              )}

            </div>

            <div
              style={{
                position: 'relative',
              }}
            >
              <Button
                options={{
                  text: logContent?.name ? "EDIT" : 'Save',
                  class: "bg-buttonRunBgColor text-4xl px-8",
                  cb: () => setSaveLogModal((data) => ({
                    ...data,
                    isOpen: true,
                    value: logContent?.name || "New",
                    onSave: (value: string) => {
                      onClickSaveRecord(value);
                      setSaveLogModal((data) => ({
                        ...data,
                        isOpen: false,
                      }));
                    },
                  })),
                }}
                style={{
                  padding: "0px 40px",
                  boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                  backgroundColor: "#406F70",
                  marginLeft: 44,
                }}
              />
              <Button
                options={{
                  text: "EXIT",
                  class: "bg-buttonRunBgColor text-4xl px-8",
                  cb: () => {
                    if (options.cb) {
                      options.cb();
                    }
                  },
                }}
                style={{
                  padding: "0px 40px",
                  boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                  backgroundColor: "#406F70",
                  marginLeft: 44,
                }}
              />

              <Button
                options={{
                  text: "FULL GRAPH",
                  cb: () => {
                    navigate(`${getRouterPath('/record-chart')}?status=log&id=${logContent?.id}&type=${options.type}`)
                  },
                }}
                style={{
                  padding: "0px 20px",
                  boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                  backgroundColor: "#406F70",
                  fontSize: 15,
                  height: 40,
                  position: 'absolute',
                  left: 450,
                  bottom: 0,
                }}
              />

            </div>



          </div>
        </div>
      </div>

      {saveLogModal.isOpen && <InputModal {...saveLogModal} />}
    </div>
  );
}
export default MenuLogRecord;
